// extracted by mini-css-extract-plugin
module.exports = {"menu":"navigation-menu_menu__2Y1fp","link":"navigation-menu_link__2iJQO","active":"navigation-menu_active__2CxCy"};